import React, { useEffect, useState, useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useFormationController } from './FormationController'
import logger from '../../../../utils/logger'
import { FILTER_DEFINITIONS } from './FILTER_DEFINTIONS'
import './formationDetail.css'
import { formationDateFormat } from '../../../../helper/formationDateFormat'
import { ProgressBar } from 'react-bootstrap'
import { FormationDetailCard } from './FormationDetailCard'
import { ActiveSearch2 } from '../../../common/activeSearchComponent2/ActiveSearch2'
import { formationDetailSearchEschema } from './FormationDetailSearchSchema'
import { applyFilters } from '../../../../helper/FilteringSearch/FilteringSearch'
import { formationStateModel } from './formationStateModel'
import { AnimatePresence, motion } from 'framer-motion';
import { LoadingComponent } from '../../../common/LoadingComponent/LoadingComponent'
import { memberActions } from './memberActions'
import { EditFormation } from './EditFormation/EditFormation'
import ReactBootstrapModal from '../../../common/modals/ReactBootstrapModal'
import { handleShare } from '../../../../helper/handleShare/handleShare'
import { EmptyDataComponent } from '../../../common/EmptyData/EmptyDataComponent'
import { useDispatch } from 'react-redux'
import { allCommonData } from '../../../../redux/slices/commonApiData'

export const FormationDetails = ({ mode }) => {

    const dispatch = useDispatch()


//? llamada a los datos comunes de la API para proveer a toda la app de la info/data
    useEffect(() => {
        dispatch(allCommonData())

    }, [dispatch])

    useEffect(() => {
        document.title = 'TPA® Admin - Detalle de Formación'
    }, [])

    const isInfoMode = mode === "info";

    const { FormationId } = useParams();
    const { formationDataById, loading, refetch } = useFormationController(FormationId);



    const [filters, setFilters] = useState({});
    const [members, setMembers] = useState([]);

    // 🔹 cargar miembros UNA vez
    useEffect(() => {
        setMembers(formationDataById?.allUsers || []);
    }, [formationDataById]);

    // 🔹 filtrado CENTRALIZADO pre y post busqueda 
    const filteredMembers = useMemo(() => {
        return applyFilters(members, filters, FILTER_DEFINITIONS);
    }, [members, filters]);



    logger.debug('filteredMembers: ', filteredMembers)
    logger.debug('activeMembersLength: ', formationDataById?.activeMembersLength)
    logger.debug('filters: ', filters)

    const activeMembersLength = formationDataById?.activeMembersLength


    const todosActivos = filteredMembers.every(member => member.isActive === false)
    const tieneCampoVacio = Object.values(filters).some(valor => valor === "");

    const arrayToUse = () => {

        logger.debug('todosActivos: ', todosActivos, 'tieneCampoVacio?: ', tieneCampoVacio)

        if (mode === 'info') {

            const onlyUserActives = filteredMembers.filter(actives => {

                return actives.isActive === true
            })


            return onlyUserActives

        } else {


            //?Si el campo del buscador esta vacio y solo hay al menos un activo
            //?Me devuelve los activos
            if (tieneCampoVacio && !todosActivos) {
                // logger.debug("El objeto tiene al menos una propiedad vacía.");

                const onlyUserActives = filteredMembers.filter(actives => {

                    return actives.isActive === true
                })

                return onlyUserActives
                // logger.debug('onlyUserActives: ', onlyUserActives)


                //?Si el campo del buscador esta vacio y solo hay inactivos
                //?Me devuelve los inactivos
            } else if (tieneCampoVacio && todosActivos) {
                const onlyUserInActives = filteredMembers.filter(actives => {

                    return actives.isActive === false
                })

                return onlyUserInActives
            } else {

                //? Cuando el buscador NO está vacio
                //? Devuelve tanto los activos como los inactivos
                return filteredMembers
            }
        };


    }





    logger.debug('arrayToUse: ', arrayToUse())



    const validateAddition = useMemo(() => {

        const maxQuota = formationDataById.formationData?.maxQuota
        const activeMembers = formationDataById?.activeMembersLength


        return maxQuota === activeMembers
    }, [formationDataById])



    const isFormationActive = (date) => {

        if (!date) return false;
        const currentDate = new Date().setHours(0, 0, 0, 0);
        const startDate = new Date(date).setHours(0, 0, 0, 0);
        return startDate >= currentDate;


    };


    const quotaPercentage = (members, maxCuota) => {
        const total = (members * 100) / maxCuota

        return total
    }

    const progressBarColor = (members, maxCuota) => {

        const percentage = quotaPercentage(members, maxCuota)

        if (percentage === 0) return "progress-bar-empty"
        if (percentage <= 75) return "progress-bar-active"
        if (percentage <= 99) return "almost-full"
        if (percentage >= 100) return "progress-bar-full"

    }

    const quotaLabel = (members, maxCuota) => {

        const percent = quotaPercentage(members, maxCuota)

        return percent === 100 ? "Completo" : "Lugares"
    }

    //?Estado para el contenedor que se oculta
    // const [isVisible, setIsVisible] = useState(true);
    const [isVisible, setIsVisible] = useState(window.innerWidth >= 767)

    const toggleAnimatePrecense = () => {
        setIsVisible(prev => !prev);
    }


    //? Setea el tipo de Modal que se visializara ALERT O MEMBERSHIP
    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(false);


    const closeBootstrapModal = () => {
        setBootstrapModalStatus(false);
    }

    const handleShow = () => {
        setBootstrapModalStatus(true)
    };


    const filteredActions = useMemo(() => {
        if (!memberActions) return null;

        const active = isFormationActive(formationDataById.formationData?.date);

        if (!active) {

            const { ADD, DELETE, ...actionsRest } = memberActions;
            return actionsRest;
        }

        return memberActions;
    }, [formationDataById.formationData?.date])







    return (

        <>

            {!loading ?

                <AnimatePresence>
                    <motion.div

                        // className='formation-detail-container'
                        className={`formation-detail-container ${mode === 'info' ? 'fdc-visitors' : ''}`}
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5, ease: 'easeInOut' }}
                    >

                        <aside className='fd-info'>


                            <div className='responsive-share-edit-2'>
                                {!isInfoMode &&
                                    <Link to="/Formations">
                                        <span className="material-symbols-outlined fd-info-back" aria-hidden="true" role="none">
                                            arrow_back
                                        </span>
                                    </Link>
                                }
                            </div>

                            <div className='fd-info-subpanel'>

                                {!isInfoMode &&

                                    <div className='responsive-share-edit'>

                                        <Link to="/Formations">
                                            <span className="material-symbols-outlined fd-info-back" aria-hidden="true" role="none">
                                                arrow_back
                                            </span>
                                        </Link>


                                        <div className="ms-edit-share-container">

                                            <span className="material-symbols-outlined fd-info-edit" aria-hidden="true" role="none" onClick={handleShow}>
                                                edit
                                            </span>

                                            <span className="material-symbols-outlined fd-info-share" aria-hidden="true" role="none"
                                                onClick={() => handleShare(FormationId)}
                                            >
                                                share
                                            </span>
                                        </div>


                                    </div>
                                }


                                <div className='title-tags-place'>


                                    <div className='fd-info-title-container d-flex align-items-center'>

                                        <h1 className='fd-info-title'>{formationDataById.formationData?.name}</h1>

                                        {!isInfoMode &&
                                            <span className="material-symbols-outlined fd-info-share responsive-share-visible" aria-hidden="true" role="none"
                                                onClick={() => handleShare(FormationId)}
                                            >
                                                share
                                            </span>
                                        }

                                    </div>

                                    <motion.div
                                        className=""
                                        style={{ overflow: "hidden" }}
                                    >
                                        <AnimatePresence initial={false}>
                                            {isVisible ? (
                                                <motion.div
                                                    key="detail"
                                                    className='fd-animatePrecense'
                                                    initial={{ opacity: 0, height: 0 }}
                                                    animate={{ opacity: 1, height: "auto" }}
                                                    exit={{ opacity: 0, height: 0 }}
                                                    transition={{ duration: 0.25, ease: "easeInOut" }}
                                                >


                                                    <div className="fd-description-container">
                                                        <p className='fd-description-text m-0 '>
                                                            {formationDataById?.formationData?.description}
                                                        </p>
                                                    </div>

                                                    <div className="fd-tags-container">
                                                        <p>Profesores: </p>

                                                        <div className="fd-info-tags d-flex">

                                                            {formationDataById?.formationData?.professors.length > 0 ?

                                                                formationDataById?.formationData?.professors.map(tag => (

                                                                    <div key={tag.id} className='fd-info-chips'>{tag.name}</div>
                                                                ))

                                                                : <div className='fd-info-chips'>No hay profesores asignados</div>}


                                                        </div>

                                                    </div>

                                                    <div className='fd-info-date-place'>

                                                        <div className="formation-calendar-container d-flex gap-2">

                                                            <span className="material-symbols-outlined formation-text-color fd-range" aria-hidden="true" role="none">
                                                                date_range
                                                            </span>

                                                            <p className='formation-text-color'>{formationDateFormat(formationDataById.formationData?.date)}</p>


                                                        </div>

                                                        <div className="formation-place-container d-flex gap-2">

                                                            <span className="material-symbols-outlined formation-text-color fd-range" aria-hidden="true" role="none">
                                                                location_on
                                                            </span>
                                                            <p className='formation-text-color'>{formationDataById.formationData?.formationPlace.name}</p>

                                                        </div>

                                                    </div>

                                                    <div className='fd-info-progressBar d-flex align-items-center gap-2'>
                                                        <ProgressBar
                                                            now={formationDataById.activeMembersLength}
                                                            max={formationDataById.formationData?.maxQuota}
                                                            className={`progress-bar-width formation-detail ${progressBarColor(formationDataById.activeMembersLength, formationDataById.formationData?.maxQuota)}`}
                                                        />

                                                        <p
                                                            className=' formation-text-color quota-label m-0 '
                                                        >
                                                            {`${formationDataById.activeMembersLength}/${formationDataById.formationData?.maxQuota} ${quotaLabel(formationDataById.activeMembersLength, formationDataById.formationData?.maxQuota)}`}
                                                        </p>
                                                    </div>

                                                    <div className="fd-info-status d-flex">

                                                        <span className={`status-circle ${isFormationActive(formationDataById.formationData?.date) ? 'bg-training-active' : 'bg-training-completed'}`}></span>

                                                        <span className={`formation-status-span ${isFormationActive(formationDataById.formationData?.date) ? 'training-active' : 'training-completed'}`}>

                                                            {isFormationActive(formationDataById.formationData?.date) ? 'Activa' : 'Finalizada'}

                                                        </span>
                                                    </div>
                                                </motion.div>
                                            ) : (
                                                <motion.div
                                                    key="compact"
                                                    className='fd-animatePrecense'
                                                    initial={{ opacity: 0, height: 0 }}
                                                    animate={{ opacity: 1, height: "auto" }}
                                                    exit={{ opacity: 0, height: 0 }}
                                                    transition={{ duration: 0.25, ease: "easeInOut" }}
                                                >
                                                    <div className='fd-responsive-date-place-maxQuota'>


                                                        <p className='formation-text-color responsive-elipsis'>{`${formationDateFormat(formationDataById.formationData?.date)} • ${formationDataById.formationData?.formationPlace.name}`}</p>

                                                        <div className='responsive-quota-container'>

                                                            <p
                                                                className=' formation-text-color quota-label fw-quota m-0 '
                                                            >
                                                                {`${formationDataById.activeMembersLength}/${formationDataById.formationData?.maxQuota} ${quotaLabel(formationDataById.activeMembersLength, formationDataById.formationData?.maxQuota)}`}
                                                            </p>

                                                        </div>

                                                    </div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </motion.div>




                                    <button className='fd-hide-details ' onClick={toggleAnimatePrecense}>

                                        {isVisible ? 'Menos información' : 'Mas información'}

                                        <span className="material-symbols-outlined formation-text-color" aria-hidden="true" role="none">

                                            {isVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}

                                        </span>
                                    </button>
                                </div>

                                {!isInfoMode &&

                                    <div className="fd-arrow-back-container" onClick={handleShow}>

                                        <span className="material-symbols-outlined fd-info-edit" aria-hidden="true" role="none">
                                            edit
                                        </span>

                                        <span>Editar</span>

                                    </div>
                                }




                            </div>



                        </aside>

                        <section className="fd-cards">

                            <div className="fd-search">
                                <ActiveSearch2
                                    disabled={members.length === 0 ? true : false}
                                    searchSchema={formationDetailSearchEschema}
                                    className="fd-search-input"
                                    onFiltersChange={setFilters}
                                />

                            </div>

                            <div className='fdc-container mb-3'>

                                {arrayToUse().length > 0 ?
                                    arrayToUse().map(member => (

                                        <FormationDetailCard
                                            key={member.id}
                                            member={member}
                                            stateModel={formationStateModel}
                                            memberActions={filteredActions}
                                            FormationId={FormationId}
                                            refetch={refetch}
                                            mode={mode}
                                            validateAddition={validateAddition}
                                            loading={loading}

                                        />


                                    )) : filteredMembers.length === 0 && !tieneCampoVacio ?

                                        <EmptyDataComponent

                                            message={'Es posible que el miembro no exista, o no se encuentre en el estado correcto, o bien ya forme parte de otra formación'}
                                        />               
                                        // <span className='fdc-noResult'>No se encontraron resultados</span>
                                        :
                                        members.length === 0 ?
                                            <EmptyDataComponent

                                                message={'Aún no hay miembros suscriptos a esta formación'}
                                            />
                                        :
                                         null
                                }





                            </div>


                        </section>



                        <ReactBootstrapModal
                            toggleModal={closeBootstrapModal}
                            showModal={bootstrapModalStatus}
                            modalClass={'modalFormation ps-0'}
                            dialogClass={'formation-dialogClass'}
                        >

                            <EditFormation
                                toggleModal={closeBootstrapModal}
                                closeBootstrapModal={closeBootstrapModal}
                                formationId={FormationId}
                                formData={formationDataById?.formationData}
                                refetch={refetch}
                                activeMembersLength={activeMembersLength}

                            />

                        </ReactBootstrapModal>

                    </motion.div>
                </AnimatePresence >

                :
                <div className='formation-loading-container'>

                    <LoadingComponent />
                    {/* <p>Cargando</p> */}

                </div>
            }
        </>




    )

}
